import { Component, OnInit, Input, DestroyRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { SkeletonComponent } from '@app/shared/components/skeleton/skeleton.component';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { LanguageService } from '@app/core/language/language.service';
import { SHARED_IMPORTS } from '@app/shared/shared.imports';

@Component({
  selector: 'app-stat',
  templateUrl: './stat.component.html',
  styleUrls: ['./stat.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatCardModule,
    MatGridListModule,
    MatIconModule,
    TranslateModule,
    SkeletonComponent,
    FlexLayoutModule,
    SHARED_IMPORTS
  ]
})
export class StatComponent implements OnInit {
  @Input() bgClass: string;
  @Input() icon: string;
  @Input() count: number;
  @Input() label: { firstLine: string; secondLine: string };
  @Input() data: number;
  @Input() loaded: boolean;

  constructor(private languageService: LanguageService) {}
  ngOnInit() {}

  get isEnglish() {
    return this.languageService.isEnglish;
  }
}
